import styled from "styled-components";

export const CardSetContainer = styled.div`
    strong {
        font-family: 'Onest';
        font-weight: 700;
    }
`;

export const ScanPersonnelContainer = styled.div`
    strong {
        font-family: 'Onest';
        font-weight: 700;
    }
`;